// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"55d4ff63baa780a1dd1c","966":"f766d6f756b239246b3a"}[chunkId] + ".js";
};